import { HERO_SERVICE } from "@/services/hero.service.js";

const state = { listOutput: null};

const actions = {
    getList({ dispatch, commit }, inputGetHeros) {
        dispatch('alert/clear', null, { root: true });
        commit('listRequest');
        
        HERO_SERVICE.list(inputGetHeros)
            .then(
                output => {
                    commit('listSuccess', output);
                },
                error => {
                    commit('listFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    /* List */
    listRequest(state) {
        state.listOutput = null;
    },
    listSuccess(state, output) {
        state.listOutput = output;
    },
    listFailure(state) {
        state.listOutput = false;
    },
};

export const hero = {
    namespaced: true,
    state,
    actions,
    mutations
};